import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import VerticalLayout from "../../VerticalLayout"

const PanelLayoutComponent = props => {
  return <VerticalLayout>{props.children}</VerticalLayout>
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = {}

PanelLayoutComponent.propTypes = {
  children: PropTypes.node,
}

export const PanelLayout = connect(
  mapStateToProps,
  mapDispatchToProps
)(PanelLayoutComponent)
